import { render, staticRenderFns } from "./PrivilegeSet.vue?vue&type=template&id=607aa627&scoped=true"
import script from "./PrivilegeSet.vue?vue&type=script&lang=js"
export * from "./PrivilegeSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607aa627",
  null
  
)

export default component.exports